// Nikura Custom Code - MISTI Bundle Builder Events - Start
// GA4 events for the NEW "pick your own oils" bundle builder (product misti-builder,
// template view simple-bundle-test; body.cro-bundle-new-layout-test). Copies the proven
// pattern of nk_pdp_upsell_event.js: push custom dataLayer events whose ecommerce.items[]
// carry item_id (SKU) / item_name; GTM custom-event triggers map them to GA4 event tags
// with "send ecommerce data from dataLayer".
//   bundle_builder_add_item  - every SUCCESSFUL add of an oil ("+" on a card or the
//                              stepper "+"): adds 1..5 only, never a removal, never a 6th.
//                              slots_filled = number of chosen oils AFTER the add.
//   bundle_builder_complete  - ONCE, only after the bundle's /cart/add.js POST returns 200
//                              (the theme's Alpine cart store adds the diffuser + the 5 oils
//                              with property _main_bundle on the diffuser line). items = the 5 oils.
// STRICT NO-OP everywhere else: unless BOTH form#atc and .bundle-add-btn exist on the page
// nothing is installed - no listeners, no fetch wrapper, no pushes, no errors. The old
// builder (no view param) and every ordinary PDP therefore behave exactly as before.
// item_list_id / item_list_name / slots_filled are ALSO pushed top-level (same values) so
// the served-draft verifier can bind them as expected_param_keys. No customer data.
// SKUs come from the page's own product JSON (variants[].sku); a variant absent from it
// falls back to the variant id as item_id (never a network call, never a blocked push).

(function () {
  "use strict";
  if (window.__nkBundleBuilderInstalled) return;

  var LIST_ID = "misti_bundle",
    LIST_NAME = "Misti Bundle Oil Selection",
    CARD = ".bundle-card",
    ADD_BUTTON = ".bundle-add-btn",
    STEP_BUTTON = ".step-btn",
    TITLE = ".bundle-card-title",
    // new layout (hidden selects) OR live layout (dropdowns)
    SELECT = "select.bundle-hidden-select, #simple-bundles-options-container-new select",
    SELECT_ITEM = /selectItem\(\s*['"](\d+)['"]\s*\)/;

  function text(el) {
    return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : "";
  }

  // Only the form is required — the /cart/add.js interceptor works on either layout
  function present() {
    return !!document.querySelector("form#atc");
  }

  function install() {
    if (window.__nkBundleBuilderInstalled || !present()) return false;
    window.__nkBundleBuilderInstalled = true;

    var catalogue = null;
    function loadCatalogue() {
      if (catalogue) return catalogue;
      catalogue = {};
      var scripts = document.scripts;
      for (var i = 0; i < scripts.length; i++) {
        var source = scripts[i].textContent || "";
        if (source.indexOf('"variants":[{"id":"') < 0 || source.indexOf('"sku":') < 0) continue;
        var re = /"variants":\[(\{[^\[\]]*?\})\]/g, match;
        while ((match = re.exec(source))) {
          var id = /"id":"(\d+)"/.exec(match[1]),
            sku = /"sku":"([^"]*)"/.exec(match[1]);
          if (id && sku && sku[1] && !catalogue[id[1]]) catalogue[id[1]] = sku[1];
        }
      }
      return catalogue;
    }

    function nameFor(variantId, card) {
      var name = text(card && card.querySelector(TITLE));
      if (name) return name;
      var selects = document.querySelectorAll(SELECT);
      for (var i = 0; i < selects.length; i++) {
        var option = selects[i].querySelector('option[value="' + variantId + '"]');
        if (option) return text(option).replace(/^\d+ml\s+/, "");
      }
      return "";
    }

    function cardFor(variantId) {
      var cards = document.querySelectorAll(CARD);
      for (var i = 0; i < cards.length; i++) {
        var button = cards[i].querySelector(ADD_BUTTON),
          click = (button && (button.getAttribute("@click") || button.getAttribute("x-on:click"))) || "",
          m = SELECT_ITEM.exec(click);
        if (m && m[1] === variantId) return cards[i];
      }
      return null;
    }

    function itemFor(variantId, card) {
      var skus = loadCatalogue();
      return {
        item_id: String(skus[variantId] || variantId),
        item_name: nameFor(variantId, card || cardFor(variantId)),
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME
      };
    }

    function chosen() {
      var ids = [], selects = document.querySelectorAll(SELECT);
      for (var i = 0; i < selects.length; i++) if (selects[i].value) ids.push(String(selects[i].value));
      return ids;
    }

    function push(payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    }

    // Per-card add tracking (new layout only; no-op on live layout)
    document.addEventListener("click", function (e) {
      var target = e.target && e.target.nodeType === 1 ? e.target : e.target && e.target.parentElement,
        button = target && target.closest ? target.closest(ADD_BUTTON + ", " + STEP_BUTTON) : null;
      if (!button) return;
      var m = SELECT_ITEM.exec(button.getAttribute("@click") || button.getAttribute("x-on:click") || "");
      if (!m) return;
      var variantId = m[1], before = chosen().length, card = button.closest(CARD), tries2 = 0;
      (function settle() {
        var ids = chosen();
        if (ids.length > before && ids.indexOf(variantId) >= 0) {
          push({
            event: "bundle_builder_add_item",
            item_list_id: LIST_ID,
            item_list_name: LIST_NAME,
            slots_filled: ids.length,
            ecommerce: { item_list_id: LIST_ID, item_list_name: LIST_NAME, items: [itemFor(variantId, card)] }
          });
          return;
        }
        if (++tries2 < 10) setTimeout(settle, 30);
      })();
    }, false);

    // Checkout button → POST /cart/add.js with a _main_bundle line → bundle_builder_complete
    var completed = false, originalFetch = window.fetch;
    if (typeof originalFetch === "function") {
      window.fetch = function (input, options) {
        var result = originalFetch.apply(this, arguments), url;
        try {
          url = new URL(input instanceof Request ? input.url : String(input), location.href);
        } catch (_) { return result; }

        if (completed || url.origin !== location.origin || url.pathname !== "/cart/add.js" ||
            !options || String(options.method || "").toUpperCase() !== "POST" ||
            typeof options.body !== "string") return result;

        var requestItems = [];
        try { requestItems = JSON.parse(options.body).items || []; } catch (_) { return result; }
        if (!Array.isArray(requestItems)) return result;

        var oils = requestItems.filter(function (it) { return !(it.properties && it.properties._main_bundle); }),
          isBundle = requestItems.some(function (it) { return it.properties && it.properties._main_bundle; }) && oils.length;

        if (isBundle) {
          result.then(function (response) {
            if (completed || !response || response.status !== 200) return;
            completed = true;
            var items = [];
            oils.forEach(function (it) {
              for (var qty = Number(it.quantity) || 1, n = 0; n < qty; n++) items.push(itemFor(String(it.id)));
            });
            push({
              event: "bundle_builder_complete",
              item_list_id: LIST_ID,
              item_list_name: LIST_NAME,
              slots_filled: items.length,
              ecommerce: { item_list_id: LIST_ID, item_list_name: LIST_NAME, items: items }
            });
          }, function () {});
        }
        return result;
      };
    }
    return true;
  }

  if (!install()) {
    var tries = 0,
      timer = setInterval(function () {
        tries++;
        if (install() || tries >= 6) clearInterval(timer);
      }, 500);
  }
})();

// Nikura Custom Code - MISTI Bundle Builder Events - End
